
























import { Component, Vue } from "vue-property-decorator";
import { ajaxDeviceInfo, ajaxComponentListByDtu } from "@/server";
// 声明组件*****************
@Component({
  components: {
    
  }
})
export default class DeviceDetail extends Vue {
  // 属性*****************
  private type: string = "loading";
 
  private deviveData: object = {
    id: '',
    device_name: '',
    status: '',
    type: '',
    address: '',
  };
  private componentData: Array<any> = [
    // {
    //   name: "id",
    //   type,
    //   src: "---",
    //   value: '22',
    //   abnormal,
    // },
  ];

  
  created(): void {
    document.title = "设备详情";
  }
  async mounted() {
    await this.getDeviceInfo();
    this.getComponentInfo();
  }
  // 方法*****************
  // 设备详情
  private getDeviceInfo(): void {
    this['$indicator'].open({
        text: '加载中...',
    });
    return ajaxDeviceInfo({
      uid: this.$store.state.user_info.info_user.user_id,
      device_id: this["$getObjectValue"](this["$route"], "query.device_id"),
      device_type: this["$getObjectValue"](this["$route"], "query.device_type")
    }).then(res => {
      this.deviveData = {
        id: this['$getObjectValue'](res.data,(res.ui[0].data.find(x=>x.fb_id == 'thing_id')||{}).jpath||''),
        device_name: this['$getObjectValue'](res.data,(res.ui[0].data.find(x=>x.fb_id == 'device_name')||{}).jpath||'')
                    ?this['$getObjectValue'](res.data,(res.ui[0].data.find(x=>x.fb_id == 'device_name')||{}).jpath||'')
                    :this['$getObjectValue'](res.data,(res.ui[0].data.find(x=>x.fb_id == 'device_model_name')||{}).jpath||''),
        status: this['$getObjectValue'](res.data,'info_device.enum_device_status.name'),
        type: this.showType(this['$getObjectValue'](res.data,'info_device.enum_device_status.status_category')),
        address: this['$getObjectValue'](res.data,(res.ui[0].data.find(x=>x.fb_id == 'compos_specific')||{}).jpath||'') || ' --',
      };
    }).catch(error => {
      console.log(error);
    })
  };

  // 设备下的 小部件详情
  private getComponentInfo(): void {
    ajaxComponentListByDtu({
      uid: this.$store.state.user_info.info_user.user_id,
      thing_id: this.$store.state.user_info.info_user.company_id,
      thing_type: this.$store.state.user_info.info_user.company_type,
      dtu_id: this["$getObjectValue"](this["$route"], "query.device_id"),
    }).then(res => {
      this.componentData = res.data.list.map(x=>{
        let obj = {};
        let currentVal = this['$getObjectValue'](x.info_sense[0],(res.ui[0].data.find(x=>x.fb_id == 'sense_latest_analog')||{}).jpath||'');
        let upper_limit = this['$getObjectValue'](x.info_sense[0],(res.ui[0].data.find(x=>x.fb_id == 'upper_limit')||{}).jpath||'');
        let lower_limit = this['$getObjectValue'](x.info_sense[0],(res.ui[0].data.find(x=>x.fb_id == 'lower_limit')||{}).jpath||'');
        
        obj['name'] = '回路'+this['$getObjectValue'](x,(res.ui[0].data.find(x=>x.fb_id == 'loop_number')||{}).jpath||'');
        if(this['$getObjectValue'](x.info_sense[0],(res.ui[0].data.find(x=>x.fb_id == 'enum_analog_type')||{}).jpath||'')==129){//电流
            obj['type']='电流';
            obj['value'] = currentVal+'mA';
            obj['src'] = '/image/dian_red.png';
            if(currentVal>upper_limit){
              obj['abnormal'] = true;
            }else if(currentVal<upper_limit && currentVal>lower_limit){
              obj['abnormal'] = false;
              obj['src'] = '/image/dian_blue.png';
            }else{
              obj['abnormal'] = true;
            }
          }else if(this['$getObjectValue'](x.info_sense[0],(res.ui[0].data.find(x=>x.fb_id == 'enum_analog_type')||{}).jpath||'')==3){//温度
            obj['type']='温度';
            obj['value'] = currentVal+'℃';
            obj['src'] = '/image/wen_red.png';
            if(currentVal>upper_limit){
              obj['abnormal'] = true;
            }else if(currentVal<=upper_limit && currentVal>=lower_limit){
              obj['abnormal'] = false;
              obj['src'] = '/image/wen_blue.png';
            }else{
              obj['abnormal'] = true;
            }
          }else{
            obj['type']='';
          }
        return obj;
      })

    }).catch(error => {
      console.log(error);
    }).finally(res=>{
      this['$indicator'].close();
    });
  };

  private showType(val:string): string {
    if(val === 'normal'){
      return 'GREEN'
    }else if(val === 'fault'){
      return 'YELLOW'
    }else if(val === 'alarm'){
      return 'RED'
    }else if(val === 'abnormal'){
      return 'RED'
    }else{
      return ''
    }
  }

}
